import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export var api__getAllOfferedDoc = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(orderId) {
    var res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetcher().get("/order-tracking/view-all-offered-documents?order_id=".concat(orderId));
        case 1:
          res = _context.v;
          return _context.a(2, res.data.data);
      }
    }, _callee);
  }));
  return function api__getAllOfferedDoc(_x) {
    return _ref.apply(this, arguments);
  };
}();